module.exports = ({
    "CDMS900MSG001": "คุณแน่ใจหรือไม่ว่าต้องการลบสถานวิจัยที่เลือกไว้?",
    "CDMS900MSG002": "คุณแน่ใจหรือไม่ว่าต้องการกู้คืนสถานวิจัยที่เลือกไว้?",
    "CDMS900MSG003": "ไม่สามารถลบสถานวิจัยที่เลือกได้ เนื่องจากมีเข้าร่วมวิจัยลงทะเบียนอยู่แล้ว",    
    "CDMS900MSG004": "ไม่สามารถลบไซต์ที่เลือกได้ เนื่องจากมีหมายเลขยา (IP No.) ถูกตั้งค่าไว้แล้ว",
    "CDMS900H001": "รหัสสถานวิจัย",
    "CDMS900H002": "ชื่อสถานวิจัย",
    "CDMS900H003": "ประเทศ",
    "CDMS900H004": "จำนวนสัญญา",
    "CDMS900H005": "วันที่ทำสัญญา",
    "CDMS900H006": "Audit Trail",
    "CDMS900H007": "ที่อยู่",
    "CDMS900H008": "Timezone",
    "CDMS900H009": "เวอร์ชัน",
    "CDMS900H010": "วันที่มีผลบังคับใช้",
    "CDMS900H011": "แผนก",
    "CDMS900H012": "ผู้แก้ไข",
    "CDMS900H013": "วันที่แก้ไข",
    "CDMS900H014": "eConsent",
    "CDMS900TT001": "การจัดการสถานวิจัย",
    "CDMS900TT002": "ประวัติการแก้ไขของ {siteCode}"
});
